/**
 * Calcula o máximo permitido ao adicionar um item de acervo compartilhado
 * a um evento. Quando o item do owner não tem `quantity` definido (legacy
 * ou nunca preenchido), não há teto.
 */
export function maxQuantityForSharedItem(item) {
  const q = item?.quantity;
  return typeof q === 'number' && q > 0 ? q : Infinity;
}

/**
 * Sanitiza a quantidade digitada pelo usuário, respeitando o máximo do item.
 * Sempre retorna inteiro >= 1.
 */
export function clampSharedItemQuantity(input, item) {
  const max = maxQuantityForSharedItem(item);
  const n = Number(input);
  if (!Number.isFinite(n)) return 1;
  return Math.max(1, Math.min(Math.floor(n), max));
}
